export const NetworkSyncModel = {
    uuid: "",
    uid: "",
    model: "",
    device_id: "",
    group_device_id: 0,
    group_device_name: "",
    group_asset_id: 0,
    group_asset_name: "",
    island_id: 0,
    island_name: "",
    config_id: 0,
    config_name: "",
    full_address: "",
    server_carry: true,
    mqtt_carry: true,
    ntp_carry: true,
    gps_carry: true,
    server_send: false,
    server_ack: false,
    server_cc_at: null,
    mqtt_send: false,
    mqtt_ack: false,
    mqtt_cc_at: null,
    ntp_send: false,
    ntp_ack: false,
    ntp_cc_at: null,
    gps_send: false,
    gps_ack: false,
    gps_cc_at: null,
    updated_at: "",
    state:false,
    queue: false,
    queue_at: null,
    params_carry:{
        battery: false,
        hibernate: false,
        default: false,
        cd: false,
        ce: false,
    },
    params_send:{
        battery: false,
        hibernate: false,
        default: false,
        cd: false,
        ce: false,
    },
    params_ack:{
        battery: false,
        hibernate: false,
        default: false,
        cd: false,
        ce: false,
    },
    params_cc_at:{
        battery: null,
        hibernate: null,
        default: null,
        cd: null,
        ce: null,
    }
}
